<template>
    <div>
        <Table border :columns="columns5" :data="data5">
            <template slot-scope="{ row ,index }" slot="completeDate">
                <Input type="textarea" v-model="row.completeDate" :autosize="{minRows: 3}" @on-change="targetItemChange(row,index,'completeDate')" />
            </template>
            
        </Table>
    </div>
</template>

<script>
export default {
    data(){
        return{
            columns5: [
                {
                    title: "行为期望",
                    key: "heighten",
                    align: "center",
                    minWidth:100
                },
                {
                    title: "描述达成目标过程中的行为期望（可参考直线经理或其他相关方对您的反馈）",
                    key: "activesPerformed",
                    align: "left",
                    type:'html',
                    minWidth:400
                },
                {
                    title: "经理对员工'如何做'的期望（列出关键行为的例子）",
                    slot: "completeDate",
                    align: "center",
                    minWidth:400
                }
            ],
            data5:[
                {
                   heighten:'协同一致',
                   activesPerformed:'<div style="margin:20px 10px">我理解我们的共同目标，并知晓如何通过我的行动确保共同目标的实现。<br /> 我主动与公司的内外部利益相关方进行交流。<br /> 我坚持以清晰方式制定决策并进行充分沟通，从而充分了解如何去执行决策。</div>'
                },
                {
                   heighten:'勇于承担',
                   activesPerformed:'<div style="margin:20px 10px">我勇于承担，发挥主人翁精神，服从执行公司的决策。<br /> 我在制定绩效时，充分考虑所需的时间和资源<br /> 我将勇于承担责任以达成目标，即便部分超出个人责任范围之外。</div>'
                },
                {
                   heighten:'付诸行动',
                   activesPerformed:'<div style="margin:20px 10px">我在规定的时间内高质高效地完成工作。<br /> 当工作没有按预期进行的时候，我勇于迅速采取正确的行动使工作进展顺利。<br /> 团队目标实现为重，我个人同获殊荣；必要时，我乐意帮助团队成员并协作他们完成任务。</div>'
                }
            ],
        }
    },
    methods:{
        
        targetItemChange(row,index,key){
            key=='completeDate'?this.$set(this.data5[index],'completeDate',row.completeDate):''
        
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/Apply/components/BehaviorExpectation.vue